"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18nResolver_1 = require("./core/I18nResolver");
exports.I18nResolver = I18nResolver_1.I18nResolver;



//////////////////
// WEBPACK FOOTER
// ./node_modules/i18n-ts/lib/i18n.js
// module id = 882
// module chunks = 0